import React, { useCallback } from "react";

import Button from "../../button/Button";
import { Trash as RemoveIcon } from "../../svg/svgImageList";

interface RemoveIconButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export default function RemoveIconButton(props: RemoveIconButtonProps) {
  const { disabled, onClick } = props;

  const clickRemove = useCallback(() => {
    onClick();
  }, [onClick]);

  return (
    <Button
      id="remove"
      onClick={clickRemove}
      disabled={disabled}
      icon={{
        svg: RemoveIcon,
        className: "remove-icon-button",
      }}
    />
  );
}
